module.exports = __webpack_public_path__ + "static/media/content-panel-button-dot.b05c5139.svg";